import React from 'react';
import { createIcon } from '../../../common';

export default class SideNavTitle extends React.Component {

 
  constructor(props) {
    super(props);
  }

  render() {
    let {title} = this.props;
    title = title || {};
    let {icon,label,iconSize}=title;
    iconSize = iconSize || 'c-icon-s3';
    return (
      <div className="user-profile d-flex flex-row justify-content-center align-items-center c-px-1">
        {icon?createIcon(icon,`${iconSize} text-white mr-2`):null}
        {label?<p className="mb-0 c-text-s2 text-white c-lh-0">{label}</p>:null}
      </div>
    );
  }
}

